import _ from 'lodash';
import baseConfig from '../base-config';
import mechanicTypes from '../../mechanic-types';

import RefData from '../../../../ref-data';

/**
 * See '/common-entities/workspace/workspaces/base-config.js' for defaults
*/
const workspaceConfig = {
  mechanics: {
    [mechanicTypes.ENTRIES]: {
      isSupported:            true,
      entrySourceStrategyIds: [RefData.Enum.STRATEGY.CAMPAIGNENTRY.ANONYMOUS, RefData.Enum.STRATEGY.CAMPAIGNENTRY.FORM],
    },
    [mechanicTypes.REWARDS]: {
      isSupported:            true,
    },
  },
};

export default _.merge({}, baseConfig, workspaceConfig);
